import { getFramePositions, getFrameScaling } from "shared/utils/door";
import type { GeometryBounds2D } from "../components/openingGeometry";
import {
  getVerticalFrameEdges,
  type FrameEdges,
  type FrameEdgesInput,
} from "./verticalLayoutUtils";

const getTransformedXBounds = (
  bounds: Pick<GeometryBounds2D, "minX" | "maxX">,
  scaleX: number,
  positionX: number,
  offsetX: number,
) => ({
  min: bounds.minX * scaleX + positionX + offsetX,
  max: bounds.maxX * scaleX + positionX + offsetX,
});

// v5/v6 keep the frame node names reversed. Match Frame.tsx's 0.86 correction
// before deriving the physical bounds.
export const getScharnierVerticalFrameEdges = ({
  width,
  height,
  leftBounds,
  rightBounds,
  topBounds,
  bottomBounds,
  frameTopScaleY,
  frameTopShiftY,
}: FrameEdgesInput): FrameEdges => {
  const framePositions = getFramePositions(width, height);
  const frameScaling = getFrameScaling(width, height);
  const horizontalCorrection = 0.86 * (1 - frameScaling.horizontal.x);

  const { min: frameLeftMin, max: frameLeftMax } = getTransformedXBounds(
    leftBounds,
    frameScaling.vertical.x,
    framePositions.left.x,
    -horizontalCorrection,
  );
  const { min: frameRightMin, max: frameRightMax } = getTransformedXBounds(
    rightBounds,
    frameScaling.vertical.x,
    framePositions.right.x,
    horizontalCorrection,
  );

  const verticalEdges = getVerticalFrameEdges({
    width,
    height,
    leftBounds,
    rightBounds,
    topBounds,
    bottomBounds,
    frameTopScaleY,
    frameTopShiftY,
  });

  return {
    ...verticalEdges,
    left: Math.min(frameLeftMin, frameRightMin),
    right: Math.max(frameLeftMax, frameRightMax),
  };
};
